import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _assertThisInitialized from "@babel/runtime/helpers/assertThisInitialized";
import _inherits from "@babel/runtime/helpers/inherits";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }
function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
import React, { PureComponent } from 'react';
import { defaultMemoize } from 'reselect';
import cx from 'classnames';
import _map from 'lodash/map';
import _isNil from 'lodash/isNil';
import _isFunction from 'lodash/isFunction';
import { EMPTY_ARRAY, EMPTY_OBJECT } from '@tekion/tekion-base/app.constants';
import FieldLayout from '../fieldLayout';
import Heading from '../../../../atoms/Heading';
import Collapse from '../../../../molecules/Collapse';
import PropertyControlledComponent from '../../../../molecules/PropertyControlledComponent';
import withGetters from '../../hoc/withGetters';
import styles from './section.module.scss';
var DEFAULT_HEADER_SIZE = 2;
var Section = /*#__PURE__*/function (_PureComponent) {
  _inherits(Section, _PureComponent);
  var _super = _createSuper(Section);
  function Section() {
    var _this;
    _classCallCheck(this, Section);
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = _super.call.apply(_super, [this].concat(args));
    _defineProperty(_assertThisInitialized(_this), "getHeader", defaultMemoize(function (headerLabel, headerClassName, values) {
      if (_isNil(headerLabel)) return null;
      return _isFunction(headerLabel) ? headerLabel(values) : /*#__PURE__*/React.createElement(Heading, {
        size: 3,
        className: cx(headerClassName)
      }, headerLabel);
    }));
    _defineProperty(_assertThisInitialized(_this), "getPanelExpandedProp", defaultMemoize(function (isPanelExpanded, collapsiblePanelKey) {
      if (isPanelExpanded) return [collapsiblePanelKey];
      return EMPTY_ARRAY;
    }));
    _defineProperty(_assertThisInitialized(_this), "renderFieldLayout", function (row, rowIndex) {
      var _assertThisInitialize = _assertThisInitialized(_this),
        props = _assertThisInitialize.props;
      return /*#__PURE__*/React.createElement(FieldLayout, {
        row: row,
        key: row.key || rowIndex,
        fields: props.fieldsGetters[rowIndex](props.fields),
        errors: props.errorsGetters[rowIndex](props.errors),
        warnings: props.warningsGetters[rowIndex](props.warnings),
        values: props.valuesGetters[rowIndex](props.values),
        onAction: props.onAction
      });
    });
    _defineProperty(_assertThisInitialized(_this), "renderSectionChildren", function (rows) {
      return _map(rows, _this.renderFieldLayout);
    });
    return _this;
  }
  _createClass(Section, [{
    key: "render",
    value: function render() {
      var props = this.props;
      var section = props.section,
        values = props.values;
      var _ref = section.header || EMPTY_OBJECT,
        headerLabel = _ref.label,
        _ref$size = _ref.size,
        headerSize = _ref$size === void 0 ? DEFAULT_HEADER_SIZE : _ref$size,
        headerClassName = _ref.className,
        _ref$hashId = _ref.hashId,
        hashId = _ref$hashId === void 0 ? '' : _ref$hashId,
        collapsible = _ref.collapsible,
        collapsiblePanelKey = _ref.collapsiblePanelKey;
      var _ref2 = section.subHeader || EMPTY_OBJECT,
        subHeaderLabel = _ref2.label,
        subHeaderClassName = _ref2.className;
      var collapsibleHeader = this.getHeader(headerLabel, headerClassName, values);
      return /*#__PURE__*/React.createElement("div", {
        id: hashId,
        "data-id": section.id,
        className: cx(styles.container, section.className)
      }, /*#__PURE__*/React.createElement(PropertyControlledComponent, {
        controllerProperty: !collapsible
      }, /*#__PURE__*/React.createElement(PropertyControlledComponent, {
        controllerProperty: headerLabel
      }, /*#__PURE__*/React.createElement(Heading, {
        size: headerSize,
        className: cx(headerClassName, styles.header)
      }, headerLabel)), /*#__PURE__*/React.createElement(PropertyControlledComponent, {
        controllerProperty: subHeaderLabel
      }, /*#__PURE__*/React.createElement(Heading, {
        size: 3,
        className: cx(subHeaderClassName, styles.subHeader)
      }, subHeaderLabel)), /*#__PURE__*/React.createElement("div", {
        className: section.sectionWrapperClassName
      }, this.renderSectionChildren(section.rows))), /*#__PURE__*/React.createElement(PropertyControlledComponent, {
        controllerProperty: collapsible
      }, /*#__PURE__*/React.createElement(Collapse, {
        defaultActiveKey: this.getPanelExpandedProp(section.isPanelExpanded, collapsiblePanelKey)
      }, /*#__PURE__*/React.createElement(Collapse.Panel, {
        bordered: false,
        panelKey: collapsiblePanelKey,
        header: collapsibleHeader
      }, this.renderSectionChildren(section.rows)))));
    }
  }]);
  return Section;
}(PureComponent);
_defineProperty(Section, "displayName", 'Section');
export default withGetters('rows')(Section);